import { Subject } from "rxjs";
import apiResponse from "../../../../services/apiResponse";
import DataTableRepository from "../Repositories/DataTableRepository";

class DataTableBloc {
  rowtableChannel = new Subject();
  cancelChannel = new Subject();

  repository = new DataTableRepository();

  constructor() {
    this.rowtableChannel.next({ status: apiResponse.INITIAL });
    this.cancelChannel.next({ status: apiResponse.INITIAL });
  }

  fetchRowTable = async (query, cancelToken) => {
    this.rowtableChannel.next({ status: apiResponse.LOADING });
    try {
      await this.repository
        .fetchList(query, cancelToken)
        .then((result) => {
          this.rowtableChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.rowtableChannel.next({ status: apiResponse.ERROR, data: error });
        });
    } catch (error) {}
  };

  cancelMeetingRegistration = async (query, cancelToken) => {
    this.cancelChannel.next({ status: apiResponse.LOADING });
    try {
      await this.repository
        .cancelMeetingRegistration(query, cancelToken)
        .then((result) => {
          this.cancelChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.cancelChannel.next({ status: apiResponse.ERROR, data: error });
        });
    } catch (error) {}
  };
}

export default DataTableBloc;
